import { mainMenu } from "./components/menu";
import { initDropdown } from "./components/dropdown";
import { faqFn } from "./components/faq";
import { headerScroll } from "./components/header";
import {
  handleHeaderFullPage,
  homeNav,
  homeTabs,
  homeTabsSlider,
} from "./components/home";
import { handleWooCommerceNotices } from "./components/notices";
import {
  ProductMiniatureGallerySlider,
  refreshSlider,
  SimpleCategories,
  AboutFeaturesSlider,
  AboutGallerySlider,
  DontForgetToAddToCartSlider,
  completeProductsSlider,
  relatedProductsSlider,
  plantTreeHowItWorksSlider,
  homeHeroSlider,
  upSellProductsSlider,
  loadHomeSliders,
} from "./components/sliders";
import { setupQuantityControls } from "./woocommerce/quantity-input";
import { setupSidePanelSizes } from "./yith-woocommerce-color-label-variations-premium/side-panel-sizes";
import { addDescriptionToImageAttribute } from "./yith-woocommerce-color-label-variations-premium/add-description-to-image-attribute";
import { subMenu } from "./components/submenu";
import { seoTextAccordion } from "./components/seoText";
import { searchBar } from "./components/search";
import { marquee } from "./components/marquee";
import { changeProductsView } from "./woocommerce/products-view";
import { customSelectInit } from "./components/customSelect";
import { lazyLoadVideo } from "./components/lazyVideo";
import { authNavigationHanlder } from "./woocommerce/auth";

import { dimensionTableHandler } from "./woocommerce/dimension-table";
import { customAside } from "./woocommerce/custom-aside";

import { updateVariationUrl } from "./woocommerce/update-variation-url";
import { tabs } from "./components/tabs";
import { productDetailsAccordion } from "./woocommerce/product-details-accordion";
import { updateProductPrice } from "./woocommerce/product-card-update-price";
import { wishlistFn } from "./components/wishlist";
import { additionalPriceInfo } from "./woocommerce/additional-price-info";
import { updateVariationEan } from "./woocommerce/update-variation-ean";

document.addEventListener("DOMContentLoaded", () => {
  const isHomePage = document.querySelector("body.home");
  const isContactPage = document.querySelector("body.page-template-contact");
  const isFaqPage = document.querySelector("body.page-template-faq");
  const isCartPage = document.querySelector("body.woocommerce-cart");
  const isShop = document.querySelector("body.woocommerce-shop");
  const isSingleProductPage = document.querySelector("body.single-product");
  const isWoocommerceProductCategory = document.querySelector(
    ".woocommerce-product-category"
  );
  const isWoocommerceAccount = document.querySelector(".woocommerce-account");
  const isAboutPage = document.querySelector("body.page-template-about");
  const isPlantTree = document.querySelector("body.page-template-plant-tree");

  // if (!isShop && !isWoocommerceProductCategory) {
  mainMenu();
  subMenu();
  // }
  window.addEventListener("scroll", () => {
    headerScroll();
  });
  initDropdown();
  handleWooCommerceNotices();

  if (isHomePage) {
    // homeNav();
    homeHeroSlider();
    homeTabs();
    homeTabsSlider();

    window.addEventListener("mousemove", loadHomeSliders, { once: true });
    window.addEventListener("scroll", loadHomeSliders, { once: true });
    window.addEventListener("touchstart", loadHomeSliders, { once: true });
  }
  if (isContactPage || isFaqPage) {
    faqFn();
  }

  if (isSingleProductPage || isWoocommerceProductCategory || isShop) {
    setupSidePanelSizes();
    additionalPriceInfo();

    jQuery(document).on("yith_wccl_product_gallery_loaded", function () {
      if (typeof refreshFsLightbox === "function") {
        refreshFsLightbox();
      }
    });
  }

  if (isSingleProductPage) {
    setupQuantityControls();
    updateProductPrice();

    ProductMiniatureGallerySlider();
    completeProductsSlider();
    customAside();
    dimensionTableHandler();
    tabs();
    productDetailsAccordion();
    relatedProductsSlider();
    upSellProductsSlider();
    // mobileProductGallery();

    updateVariationUrl();
    updateVariationEan();
  }
  if (isCartPage) {
    setupQuantityControls();
    DontForgetToAddToCartSlider();
    ProductMiniatureGallerySlider();
    customAside();
    addDescriptionToImageAttribute();
    setupSidePanelSizes();
    jQuery(document).on("yith_wccl_product_gallery_loaded", function () {
      if (typeof refreshFsLightbox === "function") {
        refreshFsLightbox();
      }
    });
  }
  if (isShop || isWoocommerceProductCategory) {
    SimpleCategories();
    ProductMiniatureGallerySlider();
    changeProductsView();
    customSelectInit();
    customAside();

    jQuery(document).on("yith-wcan-ajax-filtered", function () {
      refreshSlider("splide--simple-categories", SimpleCategories);
      refreshSlider(
        "splide--product-thumbnail-slider",
        ProductMiniatureGallerySlider
      );
      mainMenu();
      subMenu();
      // seoTextAccordion();
      customSelectInit();

      addDescriptionToImageAttribute();
      setupSidePanelSizes();
    });
  }
  if (isAboutPage) {
    AboutFeaturesSlider();
    AboutGallerySlider();
  }
  if (isWoocommerceAccount) {
    authNavigationHanlder();
  }
  if (isPlantTree) {
    plantTreeHowItWorksSlider();
  }
  seoTextAccordion();
  searchBar();
  marquee();
  lazyLoadVideo();
  addDescriptionToImageAttribute();
  wishlistFn();

  function disableArrowButtonEvents() {
    document.addEventListener("click", (event) => {
      // Sprawdzenie, czy kliknięcie dotyczy przycisku nawigacji (splide__arrow)
      if (event.target.closest(".splide__arrow")) {
        event.preventDefault();
        event.stopPropagation();
      }
    });

    const productLinks = document.querySelectorAll(
      ".woocommerce-LoopProduct-link"
    );
    if (productLinks.length) {
      productLinks.forEach((productLink) => {
        productLink.addEventListener("click", (event) => {
          // Sprawdzanie, czy kliknięcie jest na przycisku nawigacji w ramach slajdera
          if (event.target.closest(".splide__arrow")) {
            event.preventDefault();
            event.stopPropagation();
          }
        });
      });
    }
  }

  disableArrowButtonEvents();
});
